var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostControllerCommunity = /** @class */ (function () {
    function PostControllerCommunity() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/CommunityFeedPost" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {CommunityFeedPostUploadDto} data
        * @returns {CommunityFeedPostDownloadDto}
    ******************************************************************************************************/
    PostControllerCommunity.PostCommunityFeedPost = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/CommunityFeedPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return PostControllerCommunity;
}());
export { PostControllerCommunity };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerCommunity.js.map